import React from 'react';
import { RouteComponentProps } from 'react-router';

import { Sensors as SuperVendorSensors } from '../../supervendor/sensors/Sensors';

export function Sensors(props: RouteComponentProps<{}>) {
  return <SuperVendorSensors rootUrl={props.match.path} />;
}
